"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Body_1 = __importDefault(require("../../body/Body"));
var Link_1 = __importDefault(require("../../link/Link"));
var React = __importStar(require("react"));
var react_feather_1 = require("react-feather");
var Styled = __importStar(require("./FaqSectionStyles"));
var docsLinkUrl = "https://www.youtube.com/watch?v=dQw4w9WgXcQ";
var FaqSection = function (_a) {
    var question = _a.question, answer = _a.answer, linkTitle = _a.linkTitle;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var replacePlaceholderWithLink = function (text) {
        var arr = text.split("<DOCS>", 2);
        return (React.createElement(React.Fragment, null,
            arr[0],
            React.createElement(Link_1.default, { href: docsLinkUrl, target: "_blank" }, linkTitle),
            arr[1]));
    };
    return (React.createElement(Styled.Container, { onClick: function () { return setOpen(!open); }, open: open },
        React.createElement(Styled.QuestionContainer, null,
            React.createElement(Body_1.default, { withoutMargins: true }, question),
            open ? React.createElement(react_feather_1.ChevronUp, { size: 16 }) : React.createElement(react_feather_1.ChevronDown, { size: 16 })),
        open && (React.createElement(Styled.AnswerContainer, null,
            React.createElement(Body_1.default, { withoutMargins: true }, answer.includes("<DOCS>")
                ? replacePlaceholderWithLink(answer)
                : answer)))));
};
exports.default = FaqSection;
